import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { RetrieveCurrentUserResponse } from "./retrieveCurrentUser"

export const passwordLogIn = async (params: {
  email: string
  password: string
}) => {
  const { body } =
    await api.post<RetrieveCurrentUserResponse>(
      "/session-login/",
      {
        body: params,
      }
    )

  // Note if return shape of session-login and whoami diverge this needs changing to a invalidateQueries
  queryClient.setQueryData([CURRENT_USER_QUERY_KEY], body)

  return body
}
